// extracted by mini-css-extract-plugin
export var TocTitle = "table-of-contents-module--TocTitle--f3eec";
export var TocWrapper = "table-of-contents-module--TocWrapper--49b1b";